import {request} from "./request";
export function getNavList(data) {
  return request({
    url:'/navigation',
    methods:'get',
    params:data,
  })
}



// WEBPACK FOOTER //
// ./src/network/nav.js